export function filterUndefined<T extends any = any>(
  x: T | undefined | null
): x is T {
  return !!x;
}
